<script setup lang="ts">
import type { Location } from '@/entities/auth';

import LocationListItem from './LocationListItem.vue';

interface Props {
  locations: Location[];
  selectedLocationId?: string | null;
  isLoading?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  selectLocation: [locationId: string];
}>();

const handleLocationSelect = (location: Location) => {
  emit('selectLocation', location.id);
};
</script>

<template>
  <div class="flex flex-col gap-y-[8px]">
    <LocationListItem
      v-for="location in locations"
      :key="location.id"
      :location="location"
      :is-selected="location.id === selectedLocationId"
      :is-loading="isLoading"
      @select="handleLocationSelect"
    />
  </div>
</template>
